import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/logo-text.png'


const _hoisted_1 = { class: "ai-record-page" }
const _hoisted_2 = { class: "ai-record-header" }
const _hoisted_3 = {
  key: 0,
  class: "ai-record-state"
}
const _hoisted_4 = {
  key: 1,
  class: "ai-record-main"
}
const _hoisted_5 = { class: "ai-record-info" }
const _hoisted_6 = { class: "ai-record-brand" }
const _hoisted_7 = { class: "ai-record-meta ai-record-author" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ai-record-author-name" }
const _hoisted_10 = { class: "ai-record-meta ai-record-time" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "ai-record-share" }
const _hoisted_14 = { class: "ai-record-qr-card" }
const _hoisted_15 = { class: "ai-record-footer" }
const _hoisted_16 = {
  href: "https://www.envo.world/",
  target: "_blank",
  rel: "noreferrer"
}

import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { QrcodeSvg } from 'qrcode.vue'
import dayjs from 'dayjs'
import {
  AiRecordingShareDetail,
  getAiRecordingShareDetailApi,
} from '@/api/aiRecord'
import useDownloadApp from '@/hooks/useDownloadApp'
import useOpenApp from '@/hooks/useOpenApp'
import i18n from '@/language'
import PageError from '@/components/page-error.vue'
import DefaultPortrait from '@/assets/img/envo-icon-post/defaultTx.png'
import CalendarIcon from '@/assets/img/ai-record/calendar.png'
import ClockIcon from '@/assets/img/ai-record/clock.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const { downloadApp } = useDownloadApp()
const { openApp } = useOpenApp()
const qrcodeValue = ref('')
const detail = ref<AiRecordingShareDetail>()
const isShowPageError = ref(false)

const recordingId = computed(() => {
  const id = route.query.id
  return Array.isArray(id) ? id[0] : id
})

const recordDate = computed(() => {
  const createAt = detail.value?.createAt
  if (!createAt) return '-'
  const date = dayjs(createAt)
  return date.isValid() ? date.format('YYYY/MM/DD HH:mm') : createAt
})

const duration = computed(() => {
  const totalSeconds = Number(detail.value?.durationSeconds)
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) return '-'

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = Math.floor(totalSeconds % 60)
  return [hours, minutes, seconds]
    .map((value) => String(value).padStart(2, '0'))
    .join(':')
})

const setLocale = () => {
  const locale = route.query.i18n
  if (typeof locale === 'string' && locale) {
    i18n.global.locale = locale as any
  }
}

const useDefaultPortrait = (event: Event) => {
  const image = event.currentTarget as HTMLImageElement
  image.src = DefaultPortrait
}

const getAiRecordingShareDetail = async () => {
  if (!recordingId.value) {
    isShowPageError.value = true
    return
  }

  try {
    const response = await getAiRecordingShareDetailApi(recordingId.value)
    if (response.value?.code === 0 && response.value.result) {
      detail.value = response.value.result
    } else {
      isShowPageError.value = true
    }
  } catch (error) {
    isShowPageError.value = true
  }
}

onMounted(() => {
  setLocale()
  qrcodeValue.value = window.location.href
  getAiRecordingShareDetail()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        class: "ai-record-logo",
        src: _imports_0,
        alt: "Envo"
      }, null, -1)),
      _createElementVNode("button", {
        class: "ai-record-download",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(downloadApp)()))
      }, _toDisplayString(_ctx.$t('下载')), 1)
    ]),
    (isShowPageError.value)
      ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
          _createVNode(PageError)
        ]))
      : (_openBlock(), _createElementBlock("main", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("div", {
            class: "ai-record-decoration",
            "aria-hidden": "true"
          }, [
            _createElementVNode("span", { class: "decoration-arrow" })
          ], -1)),
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ai-record-brand-mark" }, [
                _createElementVNode("i"),
                _createElementVNode("i"),
                _createElementVNode("i"),
                _createElementVNode("i")
              ], -1)),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Envo", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("b", null, "|", -1)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('AI智录')), 1)
            ]),
            _createElementVNode("h1", null, _toDisplayString(detail.value?.title || '-'), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: detail.value?.portrait || _unref(DefaultPortrait),
                alt: "",
                onErrorOnce: useDefaultPortrait
              }, null, 40, _hoisted_8),
              _createElementVNode("span", _hoisted_9, _toDisplayString(detail.value?.displayName || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                class: "ai-record-time-icon",
                src: _unref(CalendarIcon),
                alt: ""
              }, null, 8, _hoisted_11),
              _createElementVNode("span", null, _toDisplayString(recordDate.value), 1),
              _createElementVNode("img", {
                class: "ai-record-time-icon clock-icon",
                src: _unref(ClockIcon),
                alt: ""
              }, null, 8, _hoisted_12),
              _createElementVNode("span", null, _toDisplayString(duration.value), 1)
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ai-record-divider" }, null, -1)),
          _createElementVNode("section", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (qrcodeValue.value)
                ? (_openBlock(), _createBlock(_unref(QrcodeSvg), {
                    key: 0,
                    value: qrcodeValue.value,
                    size: 158,
                    margin: 0,
                    level: "H"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('用Envo扫码，精彩内容快速回看')), 1)
          ]),
          _createElementVNode("button", {
            class: "ai-record-open",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args)))
          }, _toDisplayString(_ctx.$t('在Envo中打开并播放')), 1),
          _createElementVNode("footer", _hoisted_15, [
            _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('Envo官网')), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(downloadApp)()))
            }, _toDisplayString(_ctx.$t('下载Envo')), 1)
          ])
        ]))
  ]))
}
}

})